module.exports = __webpack_public_path__ + "img/parter-work1.7f6eaac7.png";